import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';


export const MissionPage = () => {
  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage-mission'>
          <img src={process.env.PUBLIC_URL + '/images/SCREENSHOT/tv_screen1.jpg'} alt="headImage" style={{ width: '100%', position:'relative' }} />  
          <h1>OUR MISSION</h1>
        </div>


        <div className='mission-content'>

          <div className='mission-content-1'>
            <div className='mission-content-1-1'>
              <h2 style={{ color:'#ffba03'}}>Revolutionize facilities management through innovative solutions</h2>
              <ul>
                <li style={{ listStyleType:'square', marginBottom:'1rem' }}>Smart solutions for facilities management</li>
                <li style={{ listStyleType:'square', marginBottom:'1rem' }}>Leverage digitalized data to enhance efficiency and accuracy</li>
                <li style={{ listStyleType:'square', marginBottom:'1rem' }}>Dynamic management dashboards provide real-time insights</li>
                <li style={{ listStyleType:'square', marginBottom:'1rem' }}>Smart network integration ensures seamless connectivity across all operations</li>
              </ul>
            </div>
            <div className='mission-content-1-1-image'>
              <img src={process.env.PUBLIC_URL + '/images/REPORT.jpg'} alt="headImage" style={{ width: '90%' }} />
            </div>
          </div>

        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>

      

    </div>
  );
}

export default MissionPage;
